<template>
  <v-layout fill-height column>
    <div class="progress-steps">
      <EmotionProgressHigh :current="5"/>
    </div>
    <div class="question min-height" v-html="ques[0]"></div>
    <div class="answer">
      <div class="text-center pb-5">
        <v-btn plain :ripple="false"
               class="primary--text"
               style="border-radius: 20px;"
               :style="{backgroundColor:bgColor}"
               @click="sheet = true">
          감정 보기<img :src="getImage('ic_down_arrow2.svg')" class="ml-2">
        </v-btn>
      </div>

      <draggable v-if="cmplt" v-model="answer" draggable="false">
        <div class="pos-relative mb-4" v-for="n in replyArr.length" :key="n">
          <div class="swipe">
                  <Textarea v-model="answer[n-1].textarea"
                            :height="140"
                            :counter="500"
                            :placeholder="answer[n-1].reply"
                            class="textarea"
                            readonly
                  />
          </div>
        </div>
      </draggable>
      <draggable v-else v-model="answer" draggable="false">
        <div class="pos-relative mb-4" v-for="n in replyArr.length" :key="n">
          <div v-touch="{
                  left: () => swipe('Left',n-1),
                  right: () => swipe('Right',n-1)
               }"
               class="swipe"
               :class="{
                  'swipe-left':swipeDirection[n-1] === 'Left',
                  'swipe-right':swipeDirection[n-1] === 'Right'
               } "
          >
            <Textarea v-model="answer[n-1].textarea"
                      :height="140"
                      :counter="500"
                      :placeholder="answer[n-1].reply"
                      class="textarea"
            />
          </div>
          <v-btn depressed plain class="swipe-btn-delete"
                 @click="textareaDelete(n-1)">삭제
          </v-btn>
        </div>
      </draggable>
      <div class="text-center">
        <v-btn v-if="!cmplt && replyCnt > answer.length"
               depressed plain class="btn-add"
               @click="btnAdd">+ 추가 작성하기
        </v-btn>
      </div>
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
    <EmotionThermometerSheet :sheet="sheet"
                             :emotionChoiceList="emotionSelectParam"
                             @close="sheetClose"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import draggable from 'vuedraggable'
import Textarea from "@/components/forms/Textarea"
import EmotionProgressHigh from "@/components/progress/EmotionProgressHigh"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
import EmotionThermometerSheet from "@/components/layout/bottomSheet/EmotionThermometerSheet";

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq", "emotionSelectParam"],
  data: () => ({
    disabledNext: true,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyArrTmp: [],
    replyObjArr: [],
    replyObjArrTmp: [],
    userReplyNo: [],
    userReply: [],
    answer: [],
    swipeDirection: [],
    replyCnt: 0,
    sheet: false,
    bgColor: '#E9E6FE',
  }),
  components: {
    draggable,
    EmotionProgressHigh,
    Textarea,
    FooterBtnsNext,
    EmotionThermometerSheet,
  },
  watch: {
    answer: {
      handler: function () {
        for (let len = 0; len < this.answer.length; len++) {
          if (this.answer[len].textarea != undefined && this.answer[len].textarea != '' && this.answer[len].textarea.length <= 500) {
            this.disabledNext = false
          } else {
            this.disabledNext = true
            break
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getUnitDetailUse()
  },
  created() {
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              this.ques.push(quesEl.ques)
              this.replyCnt = quesEl.replyCnt

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl, k) => {

                this.swipeDirection.push('Right')

                if (k < 1) {
                  this.replyArr.push(replyEl.reply)
                  // this.replyArrTmp.push(replyEl.reply)
                  this.replyObjArr.push(replyEl)
                  this.answer.push(replyEl)
                } else {
                  this.replyArrTmp.push(replyEl.reply)
                  this.replyObjArrTmp.push(replyEl)
                  // this.answer.push(replyEl)
                }
              });
              // 유저 답변 셋팅
              if (quesEl.memberUnitDtlReplyList.length > 0) {
                // 답변 비우고
                this.answer.splice(0, this.answer.length);

                quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                  this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                  userReplyEl.textarea = userReplyEl.reply
                  if (j < 1) {
                    userReplyEl.reply = this.replyArr[j]
                  } else {
                    userReplyEl.reply = this.replyArrTmp[0]
                    this.replyArr.push(this.replyArrTmp[0])
                    this.replyArrTmp.shift()
                    this.replyObjArr.push(userReplyEl)
                    this.replyObjArrTmp.shift()
                  }
                  this.answer.push(userReplyEl)

                });
              }

              // if(this.textarea[0] != '') this.textareaVaule1(this.textarea[0])
              // if(this.textarea[1] != '') this.textareaVaule2(this.textarea[1])
              // if(this.textarea[2] != '') this.textareaVaule3(this.textarea[2])

            });

          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        this.answer.forEach((replyObj, i) => {
          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: 0,
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: replyObj.textarea,
            // score: replyObj.score,
            freeYn: this.free,
            unitType: "13",
            dtlType: "18",
          }
        })

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    swipe(direction, flag) {
      this.swipeDirection.splice(flag, 1);
      this.swipeDirection.splice(flag, 0, direction);
    },
    textareaDelete(val) {
      if (this.answer.length > 1) {
        // tmp에 삽입
        this.answer[val].textarea = ''
        this.answer[val].score = 0
        this.replyArrTmp.push(this.replyArr[val])
        this.replyObjArrTmp.push(this.answer[val])

        // 삭제
        this.answer.splice(val, 1);
        this.replyArr.splice(val, 1);
        this.swipe('Right', val)
      }
    },
    btnAdd() {

      this.replyArr.push(this.replyArrTmp[0])
      this.replyArrTmp.shift()

      this.answer.push(this.replyObjArrTmp[0])
      this.replyObjArrTmp.shift()
    },
    sheetClose() {
      this.sheet = false
    }
  }
}
</script>
